import { useNavigate } from 'react-router-dom';
import { useGoal } from '../context/GoalContext';
import Card from '../components/Card';
import Button from '../components/Button';
import ProgressBar from '../components/ProgressBar';
import BottomNav from '../components/BottomNav';
import { formatCurrency, formatDate } from '../utils/calculations';
import styles from './GoalsScreen.module.css';

const GoalsScreen = () => {
  const navigate = useNavigate();
  const { savedGoals } = useGoal();

  return (
    <div className={styles.screen}>
      <div className={styles.content}>
        <h1 className={styles.heading}>Your goals</h1>

        {savedGoals.length === 0 ? (
          <div className={styles.empty}>
            <div className={styles.emptyIcon}>
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <circle cx="24" cy="24" r="18" stroke="#E0E0E0" strokeWidth="2.5"/>
                <circle cx="24" cy="24" r="10" stroke="#E0E0E0" strokeWidth="2.5"/>
                <circle cx="24" cy="24" r="3" fill="#E0E0E0"/>
              </svg>
            </div>
            <p className={styles.emptyTitle}>No active goals yet</p>
            <p className={styles.emptySub}>Start saving for something that matters to you.</p>
            <Button label="Create goal" onClick={() => navigate('/create-goal/step1')} />
          </div>
        ) : (
          <>
            <div className={styles.goalList}>
              {savedGoals.map(goal => {
                const pct = Math.round((goal.currentSaved / goal.amount) * 100);
                return (
                  <Card
                    key={goal.id}
                    className={styles.goalCard}
                    onClick={() => navigate(`/goal/${goal.id}`)}
                  >
                    <div className={styles.goalTop}>
                      <div className={styles.goalMeta}>
                        <p className={styles.goalName}>{goal.name}</p>
                        <p className={styles.goalDate}>Target: {formatDate(goal.deadline)}</p>
                      </div>
                      <div className={styles.goalRight}>
                        <span className={styles.pct}>{pct}%</span>
                      </div>
                    </div>
                    <ProgressBar current={goal.currentSaved} target={goal.amount} height={8} />
                    <div className={styles.goalBottom}>
                      <span className={styles.saved}>{formatCurrency(goal.currentSaved)} saved</span>
                      <span className={styles.target}>of {formatCurrency(goal.amount)}</span>
                    </div>
                  </Card>
                );
              })}
            </div>

            <button className={styles.addBtn} onClick={() => navigate('/create-goal/step1')}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 2V14M2 8H14" stroke="#00B8A9" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              Add another goal
            </button>
          </>
        )}
      </div>

      <BottomNav />
    </div>
  );
};

export default GoalsScreen;
